import React, {useEffect, useState} from 'react';
import {Controller, useForm} from 'react-hook-form';

import {useDispatch, useSelector} from 'react-redux';

import {
  Linking,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import {Button} from '../../../components/core/Button';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {Input} from '../../../components/core/Input';
import {globalConst} from '../../../utils/globalConstant';
import {isMobile} from '../../../utils/commonMethods';
import {CountryButton, CountryPicker} from 'react-native-country-codes-picker';
import {CountryRegEx, RegEx} from '../../../utils/commonMethods';

import {globalImport} from '../../../common/globalImports';
import Width from '../../../assets/Width';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {useNavigation} from '@react-navigation/native';

const defaultCountry = {
  name: {
    en: 'India',
  },
  dial_code: '+91',
  code: 'IN',
  flag: '🇮🇳',
};
function LoginVerify({mobVerfiedCallback, showMobVerify, isAddMoney}) {
  let userInfo = useSelector(({profile}) => profile?.profileData);
  const [error, setError] = useState('');
  const [show, setShow] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [country, setCountry] = useState({
    dial_code: userInfo?.isd_code,
    code: userInfo?.signup_country,
  });
  const [mobNo, setMobNo] = useState();
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const [selectedCountryRegEx, setSelectedCountryRegEx] = useState(
    CountryRegEx.IN,
  );

  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: {errors, isValid},
    watch,
  } = useForm({mode: 'onChange'});

  const watchNo = watch('mobileNumber');

  useEffect(() => {
    reset({
      mobileNumber: '',
    });
    setSelectedCountryRegEx(CountryRegEx[country.code]);
  }, [country, globalConfigData?.countries]);

  useEffect(() => {
    if (mobNo) {
      reset({
        mobileNumber: '',
      });
    }
  }, [mobNo]);

  useEffect(() => {
    const tempList = [];
    globalConfigData?.countries?.map(data => {
      tempList.push(data?.iso_code);
    });
    setCountryList(tempList);
  }, [globalConfigData]);

  const onFormSubmit = async (source, event) => {
    setTimeout(() => {
      if (mobNo) {
        if (mobNo !== watchNo) {
          setError(true);
        } else {
          // if (showMobVerify === 'Add Funds')
          // {
          //     const res = await Network.addMobile(
          //         {mobile: watchNo, country_code: country?.dial_code},
          //         true,
          //     );
          //     if (res?.data?.success) {
          //         dispatch(getUser());
          //         mobVerfiedCallback();
          //     }
          // }
          // else {
          if (globalImport.isWeb) {
            window.sessionStorage.setItem('paykassmaMobile', watchNo);
          }

          mobVerfiedCallback(watchNo);
          // trackMoengageEvent('Clicked on Withdraw');
          // navigation.navigate('WalletStack', {screen: 'WalletWithdraw'});
          // }
        }
      } else {
        setMobNo(watchNo);
        reset({
          mobileNumber: '',
        });
      }
    }, globalConst?.buttonTimer);
  };

  const CommonComp = () => {
    return (
      <View
        style={{
          paddingTop: 20,
          height: '100%',
        }}>
        <View style={{paddingHorizontal: 16}}>
          <Text
            style={{
              ...globalFontStyle.appFontTitle,
              color: Colors?.black,
              paddingBottom: 5,
            }}>
            {
              // showMobVerify === 'Add Funds' ?
              // (mobNo
              //     ? 'Please re-enter your phone to proceed'
              //     : 'Please enter your phone to proceed')
              // :
              mobNo
                ? 'Re-confirm'
                : isAddMoney
                ? 'Your phone no for deposit'
                : 'Your Phone Number For Withdrawal'
            }
          </Text>
          {/*{showMobVerify !== 'Add Funds' && (*/}
          <Text
            style={{
              ...globalFontStyle.appFontHeadingRegular,
              color: Colors?.lightgrey,
              paddingBottom: 5,
            }}>
            {mobNo
              ? isAddMoney
                ? 'Please recheck your phone number to avoid any transaction failure.'
                : "In case of wrong details your funds will be lost. Please make sure you're giving us correct details."
              : isAddMoney
              ? 'The payment request will be sent to your mentioned phone number'
              : 'Please enter your phone number in which you want to withdraw your winnings'}
          </Text>
          {/*)}*/}
          <View style={{paddingHorizontal: 16, paddingTop: 30}}></View>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <View style={styles.inputDiv}>
              <CountryButton
                style={{
                  countryButtonStyles: {
                    width: 65,
                    height: 45,
                    marginRight: 5,
                    marginVertical: 0,
                    paddingVertical: 5,
                    paddingHorizontal: 0,
                    backgroundColor: Colors.bgWhite,
                    borderRadius: 8,
                    justifyContent: 'space-around',
                  },
                  flag: {
                    flex: 0,
                  },
                  dialCode: {
                    flex: 0,
                    color: Colors.black,
                  },
                  // Country name styles [Text]
                  countryName: {
                    display: 'none',
                    flex: 0,
                    width: 0,
                  },
                }}
                item={country}
                onPress={mobNo ? () => {} : () => setShow(true)}
              />
              {countryList.length > 0 && !mobNo && (
                <CountryPicker
                  style={{
                    modal: {
                      shadowColor: 'rgba(34, 48, 73, 0.2)',
                      shadowOpacity: 66,
                      position: 'absolute',
                      top: 230,
                      shadowRadius: 66,
                      shadowOffset: {width: 20, height: 20},
                      height: isMobile() ? 500 : 400,
                      width: 300,
                      borderRadius: 8,
                      left: isMobile() ? 15 : Width.width / 2 + 15,
                      backgroundColor: Colors.bgWhite,
                    },
                    flag: {borderRadius: 50},
                    textInput: {
                      paddingHorizontal: 20,
                      height: 50,
                    },
                    countryButtonStyles: {
                      borderRadius: 8,
                      marginTop: 5,
                      flex: 1,
                    },
                    backdrop: {
                      backgroundColor: Colors.bgWhite,
                      opacity: 0,
                    },
                  }}
                  show={show}
                  // when picker button press you will get the country object with dial code
                  pickerButtonOnPress={item => {
                    setCountry(item);
                    setShow(false);
                  }}
                  showOnly={countryList}
                  onBackdropPress={() => setShow(false)}
                  lang={'en'}
                  inputPlaceholder={'Type your country or code'}
                  searchMessage={'Some search message here'}
                />
              )}
            </View>
            <View style={{...styles.inputDiv, marginLeft: 10, flex: 1}}>
              <Input
                name="mobileNumber"
                placeholder="Enter mobile"
                control={control}
                variant="default"
                size="default"
                numeric={true}
                prefix={country.dial_code}
                prefixStyle={{
                  color: globalConfigurableData.primaryTextColor1,
                  ...globalFontStyle.appFontBody,
                  fontSize: 15,
                  fontWeight: '500',
                  marginLeft: 14,
                }}
                rules={
                  country.code === 'IN'
                    ? {
                        required: 'Mobile number cannot be empty',
                        validate: {
                          min: value => {
                            return (
                              globalConst.MMNumbers.includes(value) ||
                              value > 1000000000 ||
                              'Please enter a valid mobile number'
                            );
                          },
                        },
                        max: {
                          value: '9999999999',
                          message: 'Please enter a valid mobile number ',
                        },
                      }
                    : {}
                }
              />
            </View>
          </View>
          {error && mobNo && watchNo !== mobNo ? (
            <FormTextLabel
              labelStyles={styles.loginErrorBar}
              label={'Verification Failed. Please retry again'}
            />
          ) : null}
          {error && mobNo && watchNo === mobNo ? (
            <FormTextLabel
              labelStyles={[styles.loginErrorBar, {color: Colors.green}]}
              label={'Verified'}
            />
          ) : null}
        </View>

        <View
          style={{
            marginTop: 20,
            paddingBottom: 15,
            marginHorizontal: 16,
          }}>
          <View style={{flexDirection: isMobile() ? 'column' : 'row'}}>
            <Button
              variant="primary"
              disabled={!isValid}
              onPress={handleSubmit(() => onFormSubmit('sms'))}
              style={{
                marginBottom: 20,
                ...(globalImport.isWeb ? (!isMobile() ? {flex: 1} : {}) : {flex: 0})
              }}
            >
              Proceed
            </Button>
          </View>
        </View>
      </View>
    );
  };

  return (
    <>
      {mobNo ? (
        <ScrollView
          contentContainerStyle={{flexGrow: 1}}
          keyboardShouldPersistTaps="handled"
          nestedScrollEnabled={true}>
          {CommonComp()}
        </ScrollView>
      ) : (
        <ScrollView
          contentContainerStyle={{flexGrow: 1}}
          keyboardShouldPersistTaps="handled"
          nestedScrollEnabled={true}>
          {CommonComp()}
        </ScrollView>
      )}
    </>
  );
}

export default React.memo(LoginVerify);

const styles = StyleSheet.create({
  loginErrorBar: {
    ...globalFontStyle.appFontSubText,
    //backgroundColor: '#ff2626',
    paddingVertical: 8,
    width: '100%',
    paddingLeft: 5,
    alignItems: 'center',
    color: Colors.red,
  },
  inputDiv: {
    flexDirection: 'row',
    marginBottom: 10,
    paddingLeft: 0,
    borderRadius: 8,
    alignItems: 'center',
    borderColor: Colors.borderColor,
    borderWidth: 1,
  },
});
